import styles from './index.module.scss';
import Teaser from './teaser';
import EfScrollAni from '@/efscrollani';

export default function ExampleProductA() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={styles.page}>
            <Teaser />
        </div>
    );
}
